import { IConfig } from '@cian/config/shared';
import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger/shared';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Provider } from 'react-redux';
import { App } from '../../components/App';
import { TReduxStore } from '../../types/redux';

export interface IApplicationContext {
  config: IConfig;
  logger: ILogger;
}

export interface IApplicationProps extends IApplicationContext {
  reduxStore: TReduxStore;
}

export type TApplicationСontextTypes = {
  [K in keyof IApplicationContext]: PropTypes.Requireable<IApplicationContext[K]>;
};

export class Application extends React.Component<IApplicationProps> {
  // TODO: переделать на React Context API
  public static childContextTypes: TApplicationСontextTypes = {
    config: PropTypes.object as any, // eslint-disable-line
    logger: PropTypes.object as any, // eslint-disable-line
  };

  public constructor(props: IApplicationProps) {
    super(props);
  }

  // TODO: переделать на React Context API
  public getChildContext(): IApplicationContext {
    return {
      config: this.props.config,
      logger: this.props.logger,
    };
  }

  public render() {
    const { logger, reduxStore } = this.props;

    return (
      <ErrorLogComponent logger={logger}>
        <Provider store={reduxStore}>
          <App />
        </Provider>
      </ErrorLogComponent>
    );
  }
}
